module.exports = __webpack_public_path__ + "img/6(1).e879d106.png";